/** "Your account" gives each tab its own route, `/account/<tab>`; the bare `/account` opens the first. */
export const ACCOUNT_TABS = ['profile', 'security'] as const;
export type AccountTab = (typeof ACCOUNT_TABS)[number];

export const ACCOUNT_TAB_LABELS: Record<AccountTab, string> = { profile: 'Profile', security: 'Security' };

export function accountTabPath(tab: AccountTab): string {
  return `/account/${tab}`;
}
